/** Academic batch label for Tally Dr Ledger, e.g. 2021-22 */
export const formatAcademicBatch = (raw) => {
  const s = String(raw || '').trim();
  if (!s || s === '—' || s === 'N/A') return '';

  const range = s.match(/^(\d{4})\s*[-–/]\s*(\d{2,4})$/);
  if (range) {
    const end = range[2].length === 4 ? range[2].slice(-2) : range[2];
    return `${range[1]}-${end.padStart(2, '0')}`;
  }

  if (/^\d{4}$/.test(s)) {
    const y = parseInt(s, 10);
    return `${y}-${String((y + 1) % 100).padStart(2, '0')}`;
  }

  return s;
};

/** Admission batch — fixed at join; not current session after promote */
export const getAdmissionBatchFromAllocation = (alloc, txn) => {
  const stored =
    txn?.studentBatch ||
    alloc?.batch ||
    alloc?.student?.admissionYear ||
    '';
  return formatAcademicBatch(stored) || '—';
};

export const getAdmissionBatchFromRow = (row) => {
  const stored = row?.batch || row?.student?.admissionYear || '';
  return formatAcademicBatch(stored) || '';
};

export const buildStudentDrLedger = (studentName, fatherName, batch) => {
  const name = (studentName || '').trim();
  if (!name) return '';
  const father = (fatherName || '').trim();
  const fatherPart = father && father !== '—' ? ` S/O ${father}` : '';
  const batchLabel = (batch || '').trim();
  const batchPart = batchLabel && batchLabel !== '—' ? ` (${batchLabel})` : '';
  return `${name}${fatherPart}${batchPart}`;
};
